import * as z from "zod";

const mnpPortoutTask = z.object({
  type: z.literal("MNP_PORTOUT"),
  state: z.enum(["ACTIVE", "INPROGRESS", "COMPLETED"]),
  taskId: z.string(),
  id: z.string(),
  properties: z.object({
    npOperator: z.string(),
    npPossibleCancelDate: z.string(),
    npMSISDN: z.string(),
    npDueDate: z.string(),
    npSubState: z.string(),
  }),
  userId: z.string(),
});
//Array can be empty
export const serverResponse = z.array(mnpPortoutTask);

export type IFetchTasksResponse = z.infer<typeof serverResponse>;

export type IMnpPortoutTask = z.infer<typeof mnpPortoutTask>;

export type TaskType = IMnpPortoutTask["type"];
